import React, { useContext } from 'react'
import { AppContext } from '../AppContext'

export default function Loading() {
    const { t } = useContext(AppContext)

    return (
        <div id='loadingDiv' role='status' aria-live='polite'>
            <div className='azan-loading-card'>
                <div className='azan-loading-orbit' aria-hidden='true'>
                    <span className='azan-loading-ring'></span>
                    <span className='azan-loading-moon'></span>
                    <span className='azan-loading-star'></span>
                </div>
                <div className='azan-loading-copy'>
                    <strong>{t('loading.title')}</strong>
                    <span>{t('loading.subtitle')}</span>
                </div>
                <div className='azan-loading-dots' aria-hidden='true'>
                    <i></i><i></i><i></i>
                </div>
                <div className='azan-loading-progress' aria-hidden='true'><span></span></div>
            </div>
        </div>
    )
}
